/* eslint-disable no-shadow */
import {
  SET_ANALYTICS_LOGGING_ENABLED,
  SET_PUBNUB_LOGGING_ENABLED,
} from '@/store/modules/dev-tools/devTools.mutations.type';
import {
  TOGGLE_ANALYTICS_LOGGING,
  TOGGLE_PUBNUB_LOGGING,
} from '@/store/modules/dev-tools/devTools.actions.type';

export const actions = {
  [TOGGLE_ANALYTICS_LOGGING]({ commit }, isEnabled) {
    commit(SET_ANALYTICS_LOGGING_ENABLED, isEnabled);
  },
  [TOGGLE_PUBNUB_LOGGING]({ commit }, isEnabled) {
    commit(SET_PUBNUB_LOGGING_ENABLED, isEnabled);
  },
};

export const mutations = {
  [SET_ANALYTICS_LOGGING_ENABLED](state, isEnabled) {
    state.analyticsLoggingEnabled = isEnabled;
  },
  [SET_PUBNUB_LOGGING_ENABLED](state, isEnabled) {
    state.pubnubLoggingEnabled = isEnabled;
  },
};

export const getters = {};

export const state = {
  analyticsLoggingEnabled: true,
  pubnubLoggingEnabled: true,
};

export default {
  actions,
  mutations,
  getters,
  state,
};
